/**
*  The Space Custom js
*/

var thespace = window.thespace || {}

thespace.customJs = function(){
	console.log('space-custom.js');
}

thespace.fixSubscriptionPriceProduct = function() {
  
  setTimeout(function() {
    var appstleWidget = jQuery("#appstle_subscription_widget0");
    if(appstleWidget.length > 0){
      
      var priceContainer = jQuery(".product__info-container .price__container");
      var newPriceContainer = priceContainer.clone();

      priceContainer.addClass('price__container__old').fadeOut(0);
      newPriceContainer.removeClass('price__container').addClass('price__container__new');
      newPriceContainer.find(".price-item--regular").removeClass('price-item--regular');

      newPriceContainer.insertBefore(".product__info-container .price__container");
      
      thespace.fixSubscriptionPriceProduct.reloadPrice = function () {
        
        var maxPrice = 0;
        var currentPrice = 0;
        appstleWidget.find('.appstle_subscription_amount').each(function () {
          var priceBox = jQuery(this);
          var value = priceBox.html();
          value = value.replace("€", "")
            .replace(".", "")
            .replace(",", ".");

          value = parseFloat(value);
    
          var isCurrent = priceBox.parent().hasClass('appstle_selected_background') || priceBox.parent().parent().hasClass('appstle_selected_background') || priceBox.parent().parent().parent().hasClass('appstle_selected_background');
          if(isCurrent){
            currentPrice = value;
          }

          if(value > maxPrice){
            maxPrice = value;
          }

          console.log('Price: ' + value);

        });

        console.log('Current Price: ' + currentPrice);
        console.log('Max Price: ' + maxPrice);

        newPriceContainer.find('.price__regular .appstle_subscription_final_price').remove();
        
        if(currentPrice < maxPrice || (currentPrice == 0 && maxPrice == 0)) {
          newPriceContainer.find('.price__regular .price-item').last().css('textDecoration', 'line-through');
          newPriceContainer.find('.price__regular .price-item').html("€" + Number(maxPrice).toFixed(2).replace(".", ","));
          newPriceContainer.find('.price__regular').prepend('<span class="price-item appstle_subscription_final_price transcy-money" style="">€' + Number(currentPrice).toFixed(2).replace(".", ",") + '</span>')
        } else {
          newPriceContainer.find('.price__regular .price-item').last().css('textDecoration', 'none');
          // newPriceContainer.find('.price__regular .price-item').remove();
          // newPriceContainer.find('.price__regular').prepend('<span class="price-item appstle_subscription_final_price transcy-money" style="">€' + Number(currentPrice).toFixed(2).replace(".", ",") + '</span>')
        }

        if(currentPrice == 0 && maxPrice == 0){
          newPriceContainer.find('.price__regular .price-item').last().fadeOut(0);
        } else {
          newPriceContainer.find('.price__regular .price-item').last().fadeIn(0);
        }

        // newPriceContainer.find('.price__sale .price-item').html("€" + Number(currentPrice).toFixed(2).replace(".", ","));  

        
      }

      var a = 1;

      thespace.fixSubscriptionPriceProduct.reloadPrice();

      jQuery("body").on("change", ".appstle_subscription_wrapper_option input", function () {
        thespace.fixSubscriptionPriceProduct.reloadPrice();
      });

      jQuery("body").on("change", ".appstle_subscribe_option select", function () {
        thespace.fixSubscriptionPriceProduct.reloadPrice();
      });
      
    }
  }, 2000);
}

thespace.newProdStyle = function() {
  // sposto le faq
  jQuery('.collapsible-content-wrapper-narrow').insertAfter('.space-left-desc');
  jQuery('.product__accordion').insertAfter('.space-left-desc');
  // sposto faq del builder
  jQuery('.2col-faq').insertAfter('.space-left-desc');
  jQuery('.collapsible-content.collapsible-row-layout').hide();

  // grafico le faq brutte
  jQuery('.2col-faq .sc-crHmcD').each(function() {
    jQuery(this).addClass('singola-faq');
  });
  
  if(jQuery(window).width() >= 1024){
    // imposto altezza blocco acquisto sulla base del blocco descrizione
    var sourceHeight = jQuery('.product .grid__item.product__media-wrapper').outerHeight();
    jQuery('.product__info-wrapper.grid__item').css('height', sourceHeight + 'px'); 
  }  
}

thespace.moveProductInfoAfeterImageMobile = function() {
  w = jQuery(window).width();
  el = jQuery('.product__info-wrapper.grid__item');
  mediaGallery = jQuery('media-gallery');
  if(w <= 480){
    console.log('siamo smartphone');
    el.insertAfter(mediaGallery);  
  }
}

jQuery(function(){
  thespace.customJs();
  thespace.fixSubscriptionPriceProduct();
  thespace.newProdStyle();
  thespace.moveProductInfoAfeterImageMobile();
});